/**
 * CheckMark mark: M5.T1.
 *
 * Hand-drawn check, used as a "correct" indicator alongside the
 * --correct color token (green flash on guess-correct).
 */
export function CheckMark({ size = 16 }: { size?: number }) {
  return (
    <svg class="mark-check" viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
      <path
        d="M 2 9 C 3.5 10 4.5 11.5 6 13 C 8 9.5 10.5 6 14 2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
